<template>
    <v-row justify="center">
        <v-dialog
            v-model="show"
            persistent
            max-width="450">
            <v-card>
                <div
                    class="close pt-3 px-7"
                    @click="close()">
                    x
                </div>
                <v-card-title class="headline flex-center">
                    {{ headerTitle }}
                </v-card-title>

                <v-card-text>
                    <v-form
                        ref="form"
                        v-model="valid">
                        <v-container>
                            <v-row>
                                <v-col cols="12">
                                    <v-text-field
                                        v-model="form.name"
                                        :rules="inputRules"
                                        :error-messages="errors.name"
                                        :label="$vuetify.lang.t('$vuetify.holidayFormModal.holidayName')"
                                        :placeholder="$vuetify.lang.t('$vuetify.holidayFormModal.enterHolidayName')">
                                    </v-text-field>
                                </v-col>
                                <v-col cols="12">
                                    <v-menu
                                        v-model="datePickerShow"
                                        :close-on-content-click="false"
                                        transition="scale-transition"
                                        offset-y
                                        min-width="234px">
                                        <template v-slot:activator="{ on }">
                                            <v-text-field
                                                v-model="dateFormatted"
                                                append-icon="event"
                                                @click:append="datePickerShow = true"
                                                @click:clear="form.date = null"
                                                :rules="inputRules"
                                                :error-messages="errors.date"
                                                readonly
                                                :label="$vuetify.lang.t('$vuetify.holidayFormModal.holiday')"
                                                placeholder="DD/MM/YYYY"
                                                v-on="on"
                                                height="40px"
                                                background-color="#ffffff">
                                            </v-text-field>
                                        </template>
                                        <v-date-picker
                                            locale="th-TH"
                                            v-model="form.date"
                                            @change="formatHolidayDate"
                                            :min="minDate"
                                            @input="datePickerShow = false">
                                        </v-date-picker>
                                    </v-menu>
                                </v-col>
                            </v-row>
                        </v-container>
                    </v-form>
                </v-card-text>

                <v-card-actions class="flex-center">
                    <v-btn
                        class="save-btn"
                        color="primary"
                        width="264"
                        @click="save()">
                        {{ $vuetify.lang.t('$vuetify.holidayFormModal.save') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-row>
</template>

<script>

export default {
    name: 'HolidayFormModal',

    props: {
        mode: {
            type: String,
            default: ''
        },
        holidayId: {
            type: Number,
            default: null
        }
    },

    data () {
        return {
            valid: true,
            datePickerShow: false,
            dateFormatted: null,
            show: true,
            form: this.getDefaultForm(),
            errors: this.getDefaultErrors(),
            minDate: this.getDateTomorrow().toISOString().substr(0, 10),
            headerTitle: ''
        }
    },

    computed: {
        inputRules () {
            return [
                v => !!v || this.$vuetify.lang.t('$vuetify.holidayFormModal.require')
            ]
        }
    },

    methods: {
        getDateTomorrow () {
            const date = new Date()
            date.setDate(date.getDate() + 1)
            return date
        },

        getHeader () {
            this.headerTitle = this.mode === 'create'
                ? this.$vuetify.lang.t('$vuetify.holidayFormModal.headerCreate')
                : this.$vuetify.lang.t('$vuetify.holidayFormModal.headerEdit')
        },

        formatHolidayDate () {
            this.dateFormatted = this.$dateUtil.formatDate(this.form.date)
        },

        getDefaultForm () {
            return {
                name: '',
                description: '',
                date: this.getDateTomorrow().toISOString().substr(0, 10)
            }
        },

        getDefaultErrors () {
            return {
                name: null,
                date: null
            }
        },

        close () {
            this.$emit('close')
        },

        async save () {
            const isValid = this.$refs.form.validate()
            if (!isValid) {
                return
            }

            await this.$store.dispatch('setLoading', true)
            if (this.mode === 'create') {
                await this.createHoliday()
            } else {
                await this.updateHoliday()
            }
        },

        async createHoliday () {
            const res = await this.axios.post('holiday/create', this.form)
            this.handleResponse(res)
        },

        async updateHoliday () {
            const res = await this.axios.put(`holiday/edit/${this.holidayId}`, this.form)
            this.handleResponse(res)
        },

        handleResponse (response) {
            if (response && response.data && response.data.status === 'ok') {
                this.$store.dispatch('setLoading', false)

                const createdText = this.$vuetify.lang.t('$vuetify.holidayFormModal.created')
                const updatedText = this.$vuetify.lang.t('$vuetify.holidayFormModal.updated')

                this.$notify({
                    title: this.$vuetify.lang.t('$vuetify.holidayFormModal.congratulation'),
                    text: this.mode === 'create' ? createdText : updatedText,
                    type: 'notify-success'
                })
                this.$emit('success')
                this.close()
            } else if (response && response.data && response.data.status === 'error_inputs') {
                this.errors = response.data.errors
                this.$store.dispatch('setLoading', false)

                for (const property in this.errors) {
                    this.$notify({
                        title: this.$vuetify.lang.t('$vuetify.holidayFormModal.errorTitle'),
                        text: this.errors[property],
                        type: 'notify-error'
                    })
                }
            }
        },

        async getHoliday () {
            const res = await this.axios.get(`holiday/${this.holidayId}`)
            if (res && res.data && res.data.status === 'ok') {
                this.form = { ...res.data.data }
            }
        }
    },

    async mounted () {
        await this.$store.dispatch('setLoading', true)
        this.getHeader()
        if (this.mode === 'update') {
            await this.getHoliday()
        }
        this.formatHolidayDate()
        await this.$store.dispatch('setLoading', false)
    },

    watch: {

    }
}
</script>

<style lang="scss" scoped>
    .flex-center {
        display: flex;
        justify-content: center;
    }
    .save-btn {
        margin-bottom: 16px;
    }
    .close {
        display: flex;
        justify-content: flex-end;
        cursor: pointer;
        font-weight: 600;
    }
</style>
